import React from "react";
import { Badge } from "reactstrap";
import style from "./style.module.scss";
import classnames from "classnames";
import { FormattedDate, FormattedTime } from "react-intl";
import { AuthorizationStatus } from "./types";

export const Status = ({ status }) => {
  return (
    <Badge className={classnames({ [style.status]: true }, { [style[status.toLowerCase()]]: true })}>
      {status.toUpperCase()}
    </Badge>
  );
};

export const ReadStatus = ({ status, wasRead }) => {
  if (status != AuthorizationStatus.Waiting && wasRead) {
    return null;
  }

  return (
    <Badge color="success" className={classnames({ [style.readStatus]: true })}>
      {status == AuthorizationStatus.Waiting ? "pending" : "unread"}
    </Badge>
  );
};

export const DateTime = ({ date }) => {
  if (date == null) {
    return "-";
  }
  return (
    <div>
      <FormattedDate value={date} /> <FormattedTime hour12={false} value={date} />
    </div>
  );
};

export function Icon({ processed, authorized }) {
  if (processed) {
    if (authorized) {
      return <i className="icon-check icons text-success"></i>;
    } else {
      return <i className="icon-close icons text-danger"></i>;
    }
  } else {
    return <i className="icon-clock icons text-info"></i>;
  }
}
